import React, { useState, useEffect } from "react";
import { Radio, RadioGroup, FormControlLabel, Typography, TextField } from '@mui/material';
import { Box } from "@mui/system";

export default function RadioButtonGroup({ apiSetting, updateApiSetting, onValidationChange }) {
  const labelWidth = 250;
  const [dataList, setDataList] = useState({});
  const [selectedOption, setSelectedOption] = useState("");
  const [otherValue, setOtherValue] = useState("");
  const [error, setError] = useState(false);

  useEffect(() => {
    setDataList(apiSetting);
    if (apiSetting?.invnumsource !== "Invoice Number" && apiSetting?.invnumsource !== "Legal Number") {
      setSelectedOption("others");
      setOtherValue(apiSetting?.invnumsource);
    } else {
      setSelectedOption(apiSetting?.invnumsource);
      setOtherValue("");
    }
  }, [apiSetting]);

  const handleRadioChange = (event) => {
    const value = event.target.value;
    setSelectedOption(value);
    if (value === "Invoice Number" || value === "Legal Number") {
      setOtherValue(""); // Clear otherValue if "Invoice Number" or "Legal Number" is selected
      setError(false);
      onValidationChange(false);
      const updatedData = { ...dataList, invnumsource: value };
      setDataList(updatedData);
      updateApiSetting(updatedData);
    }
  };

  const handleOtherTextChange = (event) => {
    const value = event.target.value;
    setOtherValue(value);
    if (value.endsWith("_c")){
      onValidationChange(false);
      setError(false);
      const updatedData = { ...dataList, invnumsource: value };
      setDataList(updatedData);
      updateApiSetting(updatedData);
    } else {
      setError(true);
      onValidationChange(true);
    }
  };

  return (
    <Box p={3}>
      <Box display="flex" alignItems="center" mb={1} sx={{ marginTop: "-40px", marginLeft: "-20px" }}>
        <Typography
          display="flex"
          alignItems="center"
          pr={2}
          sx={{ minWidth: labelWidth, paddingRight: "100px" }}
        >
          Invoice Option
        </Typography>
        <RadioGroup
          aria-label="options"
          name="options"
          value={selectedOption}
          onChange={handleRadioChange}
          row
        >
          <FormControlLabel value="Invoice Number" control={<Radio />} label="Invoice Number" />
          <FormControlLabel value="Legal Number" control={<Radio />} label="Legal Number" />
          <FormControlLabel
            value="others"
            control={<Radio />}
            label={
              <Box display="flex" alignItems="center">
                <TextField
                  label="Others"
                  placeholder="Eg: inv_legal_c"
                  value={otherValue}
                  onChange={handleOtherTextChange}
                  margin="none"
                  variant="outlined"
                  size="small"
                  error={error}
                  helperText={error ? "Input must end with '_c'" : ""}
                  sx={{ width: 170 }}
                  disabled={selectedOption !== "others"} // Disable TextField when Others option is not selected
                />
              </Box>
            }
          />
        </RadioGroup>
      </Box>
    </Box>
  );
}
